import { compose } from 'redux';
import { connect } from 'react-redux';
import VisitHistoryManagement from '../../../pages/Admin/VisitHistoryManagement/VisitHistoryManagement';
import * as Actions from '../../../actions/VisitHistoryManagement';
import withAuth from '../../../common/WithAuth';
import {
    GetListCompanyEventRequested,
    ClearGetListCompanyEvent,
} from '../../../actions/EventManagement';

const mapStateToProps = (state) => {
    const isLoading = state.visitHistoryManagement.getExhibitionViewer.isFetching
    || state.visitHistoryManagement.getSeminarViewer.isFetching
    || state.eventManagement.listCompanyEvents.isFetching
    || state.visitHistoryManagement.getLivestreamViewer.isFetching
    || state.visitHistoryManagement.getGrandBoothViewer.isFetching;

    return ({
        exhibitionList: state.visitHistoryManagement.getExhibitionViewer.data,
        exhibitionErrors: state.visitHistoryManagement.getExhibitionViewer.errors,
        successCSVExhibition: state.visitHistoryManagement.getExhibitionViewer.success,
        seminarList: state.visitHistoryManagement.getSeminarViewer.data,
        successCSVSeminar: state.visitHistoryManagement.getSeminarViewer.success,
        seminarErrors: state.visitHistoryManagement.getSeminarViewer.errors,
        listCompanyEvent: state.eventManagement.listCompanyEvents.data,
        isLoading,
        token: state.auth.credential.data.token,
        eventInfo: state.eventManagement.infoEvent.data,
        livestreamList: state.visitHistoryManagement.getLivestreamViewer.data,
        livestreamErrors: state.visitHistoryManagement.getLivestreamViewer.errors,
        successCSVLivestream: state.visitHistoryManagement.getLivestreamViewer.success,
        grandBoothList: state.visitHistoryManagement.getGrandBoothViewer.data,
        grandBoothErrors: state.visitHistoryManagement.getGrandBoothViewer.errors,
        successCSVGrandBooth: state.visitHistoryManagement.getGrandBoothViewer.success,
    });
};

const mapDispatchToProps = (dispatch) => ({
    fetchListCompanyEvent: (action) => dispatch(GetListCompanyEventRequested(action)),
    getCSVExhibitionViewer: (params) => {
        dispatch(Actions.GetExhibitionViewerRequested(params));
    },
    getCSVSeminarViewer: (params) => {
        dispatch(Actions.GetCSVSeminarViewerRequested(params));
    },
    clearExhibitionViewer: () => {
        dispatch(Actions.GetExhibitionViewerClear());
    },
    getCSVLivestreamViewer: (params) => {
        dispatch(Actions.GetCSVLivestreamViewerRequested(params));
    },
    getCSVGrandBoothViewer: (params) => {
        dispatch(Actions.GetCSVGrandBoothViewerRequested(params));
    },
    clearData: () => {
        dispatch(Actions.GetSeminarViewerClear());
        dispatch(Actions.GetExhibitionViewerClear());
        dispatch(Actions.GetLivestreamViewerClear());
        dispatch(Actions.GetGrandBoothViewerClear());
        dispatch(ClearGetListCompanyEvent());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(VisitHistoryManagement);
